module.exports = __webpack_public_path__ + "img/the-netherlands-ovarian-cancer-female.de95b8ce.png";